var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgELogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9672 10.9343L15.6782 11.8173C15.1992 12.8099 14.5447 13.7077 13.7462 14.4673C13.0319 15.1462 12.1867 15.6722 11.2622 16.0133C10.2718 16.3757 9.2258 16.5625 8.1712 16.5653C7.04133 16.6265 5.91235 16.4297 4.86984 15.9898C3.82732 15.5499 2.89865 14.8784 2.1542 14.0263C0.758529 12.4403 -0.00775552 10.3979 0.000200426 8.2853C-0.0130287 6.34602 0.628984 4.45909 1.8222 2.9303C2.55911 1.98693 3.50788 1.23043 4.59165 0.72208C5.67541 0.213728 6.86369 -0.0321738 8.0602 0.00429649C9.29179 -0.0367941 10.5153 0.217344 11.6287 0.745492C12.7421 1.27364 13.7129 2.06047 14.4602 3.0403C15.6437 4.56792 16.2497 6.46445 16.1712 8.3953H2.1002C2.07506 10.0606 2.71037 11.6681 3.8672 12.8663C4.40529 13.4375 5.05694 13.8898 5.78027 14.1941C6.5036 14.4984 7.2826 14.648 8.0672 14.6333C8.86038 14.6254 9.64575 14.4758 10.3862 14.1913C11.0881 13.9373 11.7415 13.5653 12.3182 13.0913C12.9792 12.4647 13.5359 11.7365 13.9672 10.9343ZM13.9672 6.6833C13.7603 5.74881 13.3661 4.86601 12.8082 4.0883C12.2644 3.41311 11.5628 2.88216 10.7652 2.5423C9.93751 2.14681 9.03251 1.93952 8.1152 1.9353C6.64814 1.90589 5.22559 2.43984 4.1402 3.4273C3.22423 4.31761 2.57429 5.4454 2.2632 6.6843L13.9672 6.6833Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgELogo);
export default __webpack_public_path__ + "static/media/e-logo.88af5d115c2b77c2ebf09b09cdeaee0f.svg";
export { ForwardRef as ReactComponent };